import '@accessible360/accessible-slick';
import $ from 'jquery';

const scrollSpy = (function () {
  function _init() {
    const navLinks = document.querySelectorAll('.js-scrollspy-nav .left-menu-item a');
    let sliderStatus = false;
    const makeNavLinksSmooth = () => {
      let activeLink;
      for (let n in navLinks) {
        const target = document.querySelector(navLinks[n].hash);
        if(target !== null) {
          target.classList.add('title-spy');
          target.setAttribute('tabindex','-1');
        }
        if (navLinks.hasOwnProperty(n)) {
          navLinks[n].addEventListener('click', e => {
            e.preventDefault();
            document.querySelector('.js-scrollspy-nav .left-menu-item a.active')?.classList.remove('active');
            if (activeLink) {
              activeLink.classList.remove('active');
            }
            activeLink = navLinks[n];
            activeLink.classList.add('active');
            target.focus({
              preventScroll: true
            });
            window.scrollTo({
              behavior: 'instant',
              top: target.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 120,
            });
          });
        }
      }
    };

    const spyScrolling = () => {
      const titles = document.querySelectorAll('.title-spy');
      let activeSectionIndicator = '';
      let rootMargin= '0px 0px 0px 0px';

      if (navigator.userAgent.toLowerCase().includes("chrome")) {
        rootMargin= '-40% 0px -90% 0px';
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              document.querySelector('.js-scrollspy-nav .left-menu-item a.active')?.classList.remove('active');
              activeSectionIndicator = entry.target.id;
              document
                .querySelector(`.js-scrollspy-nav .left-menu-item a[href="#${activeSectionIndicator}"]`)
                .classList.add('active');
            }
          });
        },
        {
          root: document,
          rootMargin: rootMargin
        }
      );

      titles.forEach((title) => {
        observer.observe(title);
      });
    };

    const $scrollable = $('.js-scrollspy-nav');
    function slider () {
      const $sliderWidth =  $scrollable.outerWidth();
      let $childrenWidth = 0;

      $('.scrollspy-nav--item').each(function() {
        $childrenWidth += $(this).outerWidth( true );
      });

      if ($childrenWidth > $sliderWidth) {
        sliderStatus = true;

        $scrollable.slick({
          variableWidth: true,
          slidesToScroll: 1,
          infinite: false,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Précédent"><span class="patricon' +
            ' patricon-chevron-down" aria-hidden="true"></span><span class="visually-hidden">Précédent</span></button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Suivant"><span class="patricon' +
            ' patricon-chevron-down" aria-hidden="true"></span><span class="visually-hidden">Suivant</span></button>',
          responsive: [
            {
              breakpoint: 755,
              settings: {
                centerMode: true,
              }
            }
          ]
        });
      }
    }

    makeNavLinksSmooth();
    spyScrolling();
    slider();

    $(window).on('resize', function () {
      slider();
    });
  }

  return { init: _init };
})();

export default scrollSpy;
